export default "__VITE_ASSET__CK456htS__"